<template>
    <div class="row">
        <div class="col-lg-12 text-center">
            <div style="border: none; border-radius: 10px;" class="panel panel-default country-select-panel">
                <div class="panel-body">
                    <h1>403</h1>
                    <br>
                    <h4>Access to requested resource is denied</h4>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

    export default {
        name: 'access-denied',
        data() {
            return {}
        },
        methods: {}
    }
</script>